// this is an autogenerated file from App/Account/Content/Patients/Content/Content/Sections/ActiveTab/Profile/Content/ContactInfo/Email/Emails/query-appointments.graphql
import { gql } from 'Data/Api'

export default gql`
query app__App_Account_Content_Patients_Content_Content_Sections_ActiveTab_Profile_Content_ContactInfo_Email_Emails($patient_id: uuid!) {
  appointments_upcoming_appointment_bookings_by_patient(
    args: { patient_id: $patient_id, ignored_booking_ids: "{}" }
  ) {
    id
    state
  }
}

`